import React, {useState, useEffect} from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { CloseOutlined, LoadingOutlined } from '@ant-design/icons';
import { Typography, Spin } from 'antd';
import { useParams } from 'react-router-dom';

import OrderForm from '../components/orders/OrderForm';

import * as activeOrdersConst from '../constants/activeOrders';

const { Title } = Typography;

const OrderEdit = ({ }) => {
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(null);
  const { id } = useParams();

  const fetchOrder = async () => {
    setLoading(true);
    setOrder(null)
    try {
      const { data, status } = await axios.get(`${process.env.REACT_APP_API_URL}/orders/${id}/`, {
        headers: {
          Authorization: `JWT ${window.localStorage.getItem('access')}`
        }
      });
      setLoading(false);
      if (status === 200) {
        setOrder(formatModel(data));
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrder();
  }, []);

  console.log('ola')
  
  return (
    <div className='page order-create'>
      <Link to='/orders' className='close-page'>
        <CloseOutlined
          style={{
            fontSize: 42,
            color: '#333'
          }}
        />
      </Link>
      {loading && <Spin
          indicator={
            <LoadingOutlined
              style={{
                fontSize: 32,
              }}
              spin
            />
          }
        />}
      <div className='wrapper'>
        <Title>Редактирование Ордера</Title>
        {order && order.status == activeOrdersConst.CREATED && <OrderForm order={order} />}
        {order && order.status != activeOrdersConst.CREATED && 
          <div className='order-edit__not-allowed'>
            Вы не можете редактировать активный ордер
          </div>
        }
      </div>
    </div>
  )
};

const formatModel = (_order) => {
  const order = {
    ..._order,
    ..._order.contacts,
    ..._order.item,
    currency: _order.currency.toString(),
    type_of_transport: _order.item.type_of_transport.toString(),
    type: _order.item.type.toString(),
    additional_load: _order.item.additional_load ? _order.item.additional_load.toString() : null,
    load_type: _order.load_type ? _order.load_type.split(',') : [],
    dates: {
      from: _order.from_date,
      to: _order.to_date,
    },
    uuid: _order.uuid
  }
  delete order.contacts;
  delete order.item;
  return order;
}

export default OrderEdit;